import { useMemo } from "react";
import { Inp } from "./primitives";
import { PLATAFORMAS_CONTRATADAS, parsePlataformas, formatPlataformas, semRotina } from "../plataformas";

/**
 * As plataformas em que o cliente ANUNCIA — caixinhas, não texto livre.
 *
 * O campo continua sendo `clients.notes`: o componente lê o texto,
 * devolve o texto, e preserva em "Observação" tudo que não é rótulo de
 * plataforma. Quem cadastrou "Meta Ads + Google Ads · desde mar/2026"
 * reabre o formulário e vê duas caixas marcadas e a observação intacta.
 *
 * POR QUE CADA CAIXA DIZ O QUE ACONTECE
 * Marcar uma plataforma não é etiqueta: é o gatilho de três mecanismos
 * (checklist mensal, cobrança de vínculo na Central, rotina do gestor).
 * Deixar isso implícito foi o que produziu o cliente sem tarefa. Aqui a
 * consequência está escrita ao lado da caixa, antes do clique.
 *
 * O AVISO DE "SEM ROTINA" NÃO É DECORAÇÃO
 * TikTok e GA4 são declaráveis e não geram checklist. Sem o aviso, marcar
 * TikTok repetiria exatamente o caso do Grupo THE: cadastro preenchido,
 * cliente sem tarefa, ninguém sabendo por quê.
 */
export function PlataformasPicker({ value, onChange }) {
  const { values, resto } = useMemo(() => parsePlataformas(value || ""), [value]);

  const toggle = (v) => {
    const proximos = values.includes(v) ? values.filter((x) => x !== v) : [...values, v];
    onChange(formatPlataformas(proximos, resto));
  };

  const setResto = (texto) => onChange(formatPlataformas(values, texto));

  const mudas = semRotina(values);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {PLATAFORMAS_CONTRATADAS.map((p) => {
          const marcado = values.includes(p.value);
          return (
            <label
              key={p.value}
              style={{
                display: "flex", alignItems: "flex-start", gap: 9, cursor: "pointer",
                padding: "7px 10px", borderRadius: 8,
                border: `1px solid ${marcado ? "var(--primary)" : "var(--line)"}`,
                background: marcado ? "var(--info-soft)" : "transparent",
              }}
            >
              <input
                type="checkbox"
                checked={marcado}
                onChange={() => toggle(p.value)}
                style={{ width: 15, height: 15, marginTop: 1, cursor: "pointer", accentColor: "var(--primary)" }}
              />
              <span style={{ display: "flex", flexDirection: "column", gap: 2, minWidth: 0 }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)" }}>
                  {p.label}
                  {!p.rotina && (
                    <span style={{ marginLeft: 6, fontSize: 10, fontWeight: 600, color: "var(--warn-ink)" }}>
                      sem rotina
                    </span>
                  )}
                </span>
                <span style={{ fontSize: 11, lineHeight: 1.35, color: "var(--muted)" }}>{p.hint}</span>
              </span>
            </label>
          );
        })}
      </div>

      {mudas.length > 0 && (
        <div style={{ fontSize: 11, lineHeight: 1.4, color: "var(--warn-ink)", background: "var(--warn-soft)", padding: "7px 10px", borderRadius: 8 }}>
          {mudas.map((p) => p.label).join(" e ")} {mudas.length > 1 ? "não geram" : "não gera"} checklist.
          Se esta for a única plataforma do cliente, a Virada de Mês não vai criar tarefa para ele —
          monte a rotina à mão na aba Operação.
        </div>
      )}

      <Inp
        value={resto}
        onChange={(e) => setResto(e.target.value)}
        placeholder="Observação (opcional): desde mar/2026, verba sazonal…"
      />

      {values.length === 0 && !resto && (
        <div style={{ fontSize: 11, lineHeight: 1.4, color: "var(--danger)" }}>
          Sem nenhuma plataforma marcada o cliente não recebe tarefa mensal, some do briefing diário
          e aparece como cadastro incompleto na Platform.
        </div>
      )}
    </div>
  );
}
